import { z } from 'zod';

import { TranslationFnMap } from '~shared/i18n';

type ResetErrorsKey = 'EMAIL_REQUIRED' | 'EMAIL_INVALID';

type ResetFormErrors = TranslationFnMap<ResetErrorsKey>;

const resetSchema = z.object({
  email: z
    .string()
    .min(1, { error: 'EMAIL_REQUIRED' })
    .regex(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, {
      error: 'EMAIL_INVALID',
    }),
});

type ResetFormData = z.infer<typeof resetSchema>;

export { type ResetFormData, type ResetFormErrors, resetSchema };
